import React from "react";
import { Link } from "react-router-dom";
import FooterOneAr from "../Footer/FooterOneAr";
import Header from "../Header/HeaderTwo";
import { pageTitle } from "../PageTitle";

const ServicesDetailsAr = () => {
  pageTitle("Services Details");
  return (
    <>
      <Header></Header>
      <div className="services__details section-padding">
        <div className="container" dir="rtl">
          <div className="row">
            <div className="col-xl-12 col-lg-8">
              <div className="services__details-left">
                <div
                  className="services__details-left-content mb-40"
                  style={{ paddingTop: "13%" }}
                >
                  {/* <h2 className="mb-30">Terms & Conditions</h2> */}
                  <div className="contact__area-title">
                    <span className="subtitle">الشروط والأحكام</span>
                  </div>
                  <ol type="1">
                    <li>قبول الشروط</li>
                    <p>
                      من خلال الوصول أو استخدام التطبيق، فإنك توافق على الالتزام
                      بهذه الشروط، والتي تشكل اتفاقية قانونية ملزمة بينك وبين
                      وكالة عقارات البروكر (البروكر Brokerage). تنطبق هذه الشروط
                      على جميع مستخدمي التطبيق، بما في ذلك ولكن لا تقتصر على
                      الوكلاء والمشترين والبائعين والمستعرضين.
                    </p>
                    <li>استخدام التطبيق</li>
                    <p>
                      توافق على استخدام التطبيق فقط للأغراض المقصودة. قد لا
                      تستخدم التطبيق لأي غرض غير مشروع أو محظور. كما توافق على
                      عدم: انتهاك أي قوانين أو لوائح سارية المفعول. التدخل أو
                      التعدي على عمل التطبيق. محاولة الوصول غير المصرح به إلى أي
                      جزء من التطبيق. استخدام التطبيق بأي طريقة يمكن أن تتسبب في
                      تلف أو تعطيل أو إعباء أو تعطيل التطبيق أو التداخل مع
                      استخدام أي طرف آخر للتطبيق. المشاركة في أي سلوك يقيد أو
                      يعيق أي مستخدم آخر من استخدام أو الاستمتاع بالتطبيق.
                    </p>
                    <li>التسجيل والحسابات</li>
                    <p>
                      من أجل الوصول إلى بعض ميزات التطبيق، قد يتطلب منك التسجيل
                      للحصول على حساب. عند التسجيل للحصول على حساب، فإنك توافق
                      على تقديم معلومات دقيقة وكاملة. أنت مسؤول عن الحفاظ على
                      سرية بيانات الاعتماد الخاصة بحسابك وعن جميع الأنشطة التي
                      تحدث تحت حسابك.
                    </p>
                    <li>الملكية الفكرية</li>
                    <p>
                      جميع المحتوى المتضمن في التطبيق، بما في ذلك النصوص
                      والرسومات والشعارات والصور ومقاطع الصوت والبرمجيات، هو ملك
                      لوكالة عقارات البروكر أو مرخصيها ومحمي بقوانين الملكية
                      الفكرية. قد لا تستخدم، أو تستنسخ، أو توزع، أو تعرض أي جزء
                      من التطبيق دون الحصول على موافقة كتابية مسبقة من وكالة
                      عقارات البروكر.
                    </p>
                    <li>روابط الطرف الثالث</li>
                    <p>
                      قد يحتوي التطبيق على روابط إلى مواقع وخدمات الطرف الثالث
                      التي لا تملكها أو تحكمها وكالة عقارات البروكر. لا تمتلك
                      وكالة عقارات البروكر أي تحكم على محتوى أو سياسات الخصوصية
                      أو الممارسات لأي مواقع أو خدمات الطرف الثالث. من خلال
                      استخدام التطبيق، فإنك تُطلق بشكل صريح وكالة عقارات البروكر
                      من أي مسؤولية تنشأ عن استخدامك لأي موقع أو خدمة من الطرف
                      الثالث.
                    </p>
                    <li>إخلاء المسؤولية عن الضمانات</li>
                    <p>
                      يتم توفير التطبيق على أساس "كما هو" و "حسب التوافر"، دون
                      أي ضمانات من أي نوع، سواء كانت صريحة أو ضمنية. تخلي وكالة
                      عقارات البروكر عن جميع الضمانات، بما في ذلك ولكن لا تقتصر
                      على ضمانات التسويقية، واللياقة لغرض معين، وعدم انتهاك
                      الحقوق.
                    </p>
                    <li>تقييد المسؤولية</li>
                    <p>
                      إلى أقصى حد يسمح به القانون، لن تكون وكالة عقارات البروكر
                      مسؤولة عن أي أضرار غير مباشرة أو عرضية أو خاصة أو عقابية،
                      أو أي خسائر في الأرباح أو الإيرادات، سواء كانت تكبدت
                      مباشرة أو غير مباشرة، أو أي فقدان للبيانات، أو الاستخدام،
                      أو الود، أو أية خسائر لا مادية أخرى، ناتجة عن وصولك إلى أو
                      استخدامك لأو عدم القدرة على الوصول أو استخدام التطبيق؛ أي
                      سلوك أو محتوى من جانب أي طرف ثالث على التطبيق؛ أو الوصول
                      غير المصرح به أو الاستخدام أو التغيير غير المصرح به
                      لنقلاتك أو محتواك.
                    </p>
                    <li>التعويض</li>
                    <p>
                      توافق على تعويض وحماية وكالة عقارات البروكر من أي وجميع
                      المطالبات والمسؤوليات والأضرار والتكاليف والنفقات، بما في
                      ذلك رسوم المحاماة المعقولة، ناتجة عن أو مرتبطة باستخدامك
                      للتطبيق أو انتهاكك لهذه الشروط. 9. التغييرات على الشروط
                      تحتفظ وكالة عقارات البروكر بالحق في تعديل أو تعديل هذه
                      الشروط في أي وقت، وستكون هذه التغييرات فعالة على الفور
                      بمجرد نشرها على التطبيق. يشكل استمرارك في استخدام التطبيق
                      بعد نشر أي تغييرات على هذه الشروط موافقتك على تلك
                      التغييرات
                    </p>
                    <li>
                    القانون الساري
                    </li>
                    <p>
                    تخضع هذه الشروط للقوانين وتفسيرها وفقًا لقوانين ، دون الالتفات إلى مبادئ التعارض في القوانين.
                    </p>
                    <li>
                    اتصل بنا
                    </li>
                    <p>
                    إذا كان لديك أي أسئلة حول هذه الشروط، يرجى الاتصال بنا على [elbrokerapp@gmail.com].
                    </p>
                  </ol>
                  {/* <p>
                    Research for your next design project is done by a team of
                    industry experts. We help with research, data analysis, and
                    visualization. Our expertise covers many different fields
                    including UX Design, Brand Strategy, Content Writing, User
                    Experience Design and more.
                  </p> */}
                </div>
                {/* <div className="services__details-left-image mb-60">
                  <img src="assets/img/services_details-1.jpg" alt="" />
                  <div className="row mt-30">
                    <div className="col-sm-6 sm-mb-30">
                      <img
                        className="img__full"
                        src="assets/img/services_details-2.jpg"
                        alt=""
                      />
                    </div>
                    <div className="col-sm-6">
                      <img
                        className="img__full"
                        src="assets/img/services_details-3.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div> */}
                {/* <div className="services__details-left-feedback">
                  <div className="row">
                    <div className="col-xl-6 xl-mb-30">
                      <div className="feedback__area-item">
                        <div className="feedback__area-item-quote">
                          <img src="assets/img/icon/quote.png" alt="" />
                        </div>
                        <div className="feedback__area-item-reviews">
                          <h5>Good :</h5>
                          <ul>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        <div className="feedback__area-item-content">
                          <p>
                            pellentesque in dolor vel malesuada. Donec finibus
                            libero odio, ac iaculis metus mattis quis.
                          </p>
                        </div>
                        <div className="feedback__area-item-bottom">
                          <div className="feedback__area-item-bottom-avatar">
                            <img
                              src="assets/img/avatar/feedback-1.jpg"
                              alt=""
                            />
                          </div>
                          <div className="feedback__area-item-bottom-title">
                            <h5>david bowie</h5>
                            <span>UX Designer</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 lg-mb-30">
                      <div className="feedback__area-item">
                        <div className="feedback__area-item-quote">
                          <img src="assets/img/icon/quote.png" alt="" />
                        </div>
                        <div className="feedback__area-item-reviews">
                          <h5>Good :</h5>
                          <ul>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        <div className="feedback__area-item-content">
                          <p>
                            pellentesque in dolor vel malesuada. Donec finibus
                            libero odio, ac iaculis metus mattis quis.
                          </p>
                        </div>
                        <div className="feedback__area-item-bottom">
                          <div className="feedback__area-item-bottom-avatar">
                            <img
                              src="assets/img/avatar/feedback-2.jpg"
                              alt=""
                            />
                          </div>
                          <div className="feedback__area-item-bottom-title">
                            <h5>michel aoun</h5>
                            <span>Marketing</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
            {/* <div className="col-xl-4 col-lg-4">
              <div className="all__sidebar ml-25 xl-ml-0">
                <div className="all__sidebar-item services">
                  <h4>Our Services</h4>
                  <div className="all__sidebar-item-category">
                    <ul>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>Design
                          Research<span>(08)</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>
                          Development<span>(06)</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>Digital
                          Marketing<span>(05)</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>Branding
                          <span>(09)</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>Market
                          Research<span>(03)</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>SEO
                          marketing<span>(02)</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className="all__sidebar-item-help"
                  style={{ backgroundImage: `url('assets/img/details-3.jpg')` }}
                >
                  <h4>Need Any Help?</h4>
                  <div className="all__sidebar-item-help-contact">
                    <div className="all__sidebar-item-help-contact-icon">
                      <i className="fal fa-phone-alt"></i>
                    </div>
                    <div className="all__sidebar-item-help-contact-content">
                      <span>Quick Help</span>
                      <h6>
                        <a href="tel:+123(458)896895">01552710828</a>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <FooterOneAr></FooterOneAr>
    </>
  );
};

export default ServicesDetailsAr;
